<template>
    <div class="p-4 rounded" :class="wrapperClassName">
        <div class="flex">
            <div class="flex-shrink-0" :class="{ 'inline-flex items-center': !title }">
                <nio-icon class="text-base text-blue-500" name="bold/information-circle" v-if="type == 'info'" />
                <nio-icon class="text-base text-green-500" name="bold/check-circle-1" v-if="type == 'success'" />
                <nio-icon class="text-base text-yellow-500" name="bold/alert-triangle" v-if="type == 'warning'" />
                <nio-icon class="text-base text-red-500" name="bold/remove-circle" v-if="type == 'error'" />
            </div>
            <div class="ml-3">
                <h3
                    class="text-sm font-medium mb-1"
                    :class="titleClassName"
                    v-text="title"
                    v-if="title"
                />
                <div class="text-sm" :class="contentClassName">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: 'info',
                validator: (value) => ['info', 'success', 'warning', 'error'].includes(value),
            },
        },

        computed: {
            wrapperClassName() {
                switch (this.type) {
                    case 'success':
                        return 'bg-green-100';
                    case 'warning':
                        return 'bg-yellow-100';
                    case 'error':
                        return 'bg-red-100';
                    case 'info':
                    default:
                        return 'bg-blue-100';
                }
            },

            titleClassName() {
                switch (this.type) {
                    case 'success':
                        return 'text-green-800';
                    case 'warning':
                        return 'text-yellow-800';
                    case 'error':
                        return 'text-red-800';
                    case 'info':
                    default:
                        return 'text-blue-800';
                }
            },

            contentClassName() {
                switch (this.type) {
                    case 'success':
                        return 'text-green-700';
                    case 'warning':
                        return 'text-yellow-700';
                    case 'error':
                        return 'text-red-700';
                    case 'info':
                    default:
                        return 'text-blue-700';
                }
            },
        },
    };
</script>
